import { SlideComponentHkcsQ1 } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentHkcsQ1Creator extends SlideComponentCreator {
    public create(id: string): SlideComponentHkcsQ1 {
        return {
            id: id,
            type: 'hkcsQ1',
            pos: {
                x: 0,
                y: 0,
            },
            size: {
                width: 200,
                height: 200,
            },
            content: {
                characterList: [],
                character: 0,
                characterSound: {
                    jyutping: [],
                    pinyin: [],
                },
                phrase: '',
                phraseSound: {
                    jyutping: [],
                    pinyin: [],
                },
                phraseSoundGroup: {
                    jyutping: [],
                    pinyin: [],
                },
                image1: '',
                image1URL: '',
                keyword1: '',
                image2: '',
                image2URL: '',
                keyword2: '',
                questionCount: 4,
                questions: Array.from({ length: 4 }, (_, i) => ({
                    id: crypto.randomUUID(),
                    image: '',
                    imageURL: '',
                    flip: 1,
                    sort: i,
                })),
            },
        };
    }
}
